import { Component, OnInit } from '@angular/core';
import { Observable, of, Subject } from "rxjs";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomDialogService } from 'src/app/shared/custom-dialog.service';

@Component({
  selector: 'app-submitter-details-dialogue',
  templateUrl: './submitter-details-dialogue.component.html',
  styleUrls: ['./submitter-details-dialogue.component.scss']
})
export class SubmitterDetailsDialogueComponent implements OnInit {

  private actionSubject = new Subject();
  action$ = this.actionSubject.asObservable();
  submitterData: any;
  actionType: string;
  successTitle = 'DONE';

  constructor(
    public activeModal: NgbActiveModal,
    private readonly customDialogService: CustomDialogService
  ) { }

  ngOnInit() {
    this.submitterData = this.customDialogService.getSubmitterDetails();
    console.log('data of submitter ', this.submitterData);
    this.configButtons();
  }
  
  onOk() {
    this.actionSubject.next(this.actionType);
    this.activeModal.dismiss();
  }

  configButtons() {
    if (this.actionType === 'dismiss') {
        this.successTitle = 'DONE';
    }
  }

}
